import PersonAddIcon from '@material-ui/icons/PersonAdd';
import SixmonthList from './SixmonthList'

export default {
    list: SixmonthList,
    icon: PersonAddIcon,
};
